module.exports = __webpack_public_path__ + "static/media/Icons_25 nov-05 (1).98faa5c5.svg";